import { Guid } from 'guid-typescript';

export class FileUploadModel {
    workId: string ;
    name: string;

    constructor() {
        this.workId = Guid.EMPTY ;
        this.name = null;
    }
}

export function CreateBlankFileUpload(): FileUploadModel {
    return new FileUploadModel() ;
}
